import withPropsOnChange from 'recompose/withPropsOnChange';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import {
  fetchOwnerPromoCode,
} from '../../main/settings/promoCodes/actions';
import withFetchCampaign from '../hoc/withFetchCampaign';
import PayCampaign from '../components/PayCampaign';
import { CAMPAIGN_TYPE } from '../constants';
import { getRoleIdType } from '../../auth/selectors';
import withActiveUserIdAndType from '../../common/hoc/withActiveUserIdAndType';

const PayCampaignContainer = compose(
  withActiveUserIdAndType(),
  connect(
    state => ({
      showPushPreview: state.engagement.campaign.sendPush || state.engagement.campaign.sendSms,
      shopOrBarber: getRoleIdType(state),
      promoId: state.engagement.campaign.promoId,
      isRecurringCampaign: state.engagement.campaign.type === CAMPAIGN_TYPE.recurring,
    }),
    dispatch => ({
      fetchPromo: bindActionCreators(fetchOwnerPromoCode, dispatch),
    }),
  ),
  withHandlers({
    fetchPromo: props => id => props.fetchPromo(props.activeId, props.activeType, id),
  }),
  withFetchCampaign,
  lifecycle({
    componentDidMount() {
      this.props.fetchCampaign();
    },
  }),
  withPropsOnChange(
    ['promoId'],
    (props) => {
      if (props.promoId) props.fetchPromo(props.promoId);
    },
  )
)(PayCampaign);

export default PayCampaignContainer;
